module.exports = __webpack_public_path__ + "3d52112843fdf68f93a1a9848092875b.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/social/speakers/kate-compton.jpg
// module id = 515
// module chunks = 0